import { render, staticRenderFns } from "./SelectLink.vue?vue&type=template&id=127798e6"
import script from "./SelectLink.vue?vue&type=script&lang=js"
export * from "./SelectLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports